module.exports = __webpack_public_path__ + "static/sec5-bg-sm-06c10faaf00d592652cc7868ed9c52d1.jpg";